import { Box } from "@mui/material";
import { motion } from "framer-motion";

const AnimatedBackground = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      {/* Blob 1 */}
      <Box
        component={motion.div}
        animate={{ x: [0, 80, 0], y: [0, 60, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
        sx={{
          position: "absolute",
          top: "-10%",
          left: "-10%",
          width: 420,
          height: 420,
          borderRadius: "50%",
          background: "rgba(124,58,237,0.25)",
          filter: "blur(120px)",
        }}
      />

      {/* Blob 2 */}
      <Box
        component={motion.div}
        animate={{ x: [0, -70, 0], y: [0, -50, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
        sx={{
          position: "absolute",
          bottom: "-15%",
          right: "-10%",
          width: 380,
          height: 380,
          borderRadius: "50%",
          background: "rgba(99,102,241,0.25)",
          filter: "blur(120px)",
        }}
      />

      {/* Center Accent */}
      <Box
        component={motion.div}
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
        sx={{
          position: "absolute",
          top: "35%",
          left: "40%",
          width: 260,
          height: 260,
          borderRadius: "50%",
          background: "rgba(168,85,247,0.2)",
          filter: "blur(120px)",
        }}
      />
    </Box>
  );
};

export default AnimatedBackground;
